export const getIsMobileCustomizable = (eventType: string) => eventType === "greeting_card" || eventType === "rsvp_event";

export const canDeviceCustomizeCard = (
  isMobile: boolean,
  isIOSDevice: boolean,
  isMobileCustomizable: boolean
) => {
  return !isMobile || isIOSDevice || isMobileCustomizable;
};
